<div *ngIf="currentLoadingStatus" class="loading-container">
  <nz-spin nzSimple nzSize="large"></nz-spin>
</div>
